import { BACKEND_URL } from "../../config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Feature #13 — native BFF-backed read-only tables that replace the public
// Airtable share-link iframes. The BFF enforces the Position gate server-side
// on every load (see nativeViewsController), so there's no shareable URL to leak.
export const nativeViewsApi = createApi({
  reducerPath: "nativeViewsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getNativeView: builder.query({
      query: (viewKey) => `/native-views/portal/get/${viewKey}`,
    }),
  }),
});

export const { useGetNativeViewQuery } = nativeViewsApi;
